import { render, staticRenderFns } from "./index.vue?vue&type=template&id=984c7ffa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=984c7ffa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984c7ffa",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonNumberAnimate: require('/builds/wj/fe/wenjuan-homesite/components/common/number-animate.vue').default,CommonStretchBanner: require('/builds/wj/fe/wenjuan-homesite/components/common/stretch-banner.vue').default,CommonToggleWrap: require('/builds/wj/fe/wenjuan-homesite/components/common/toggle-wrap.vue').default})
